import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderSlot as _renderSlot, createTextVNode as _createTextVNode, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "navbar__first--fixed"
}
const _hoisted_2 = {
  key: 1,
  class: "navbar__first"
}
const _hoisted_3 = { class: "navbar__items" }
const _hoisted_4 = { class: "navbar__item" }
const _hoisted_5 = { class: "navbar__item" }
const _hoisted_6 = { class: "navbar__item" }
const _hoisted_7 = { class: "navbar__item--mobile" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Docs")
const _hoisted_9 = { class: "navbar__items--last" }
const _hoisted_10 = { class: "navbar__item--mobile" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Sign out ")
const _hoisted_12 = { class: "navbar__item--mobile" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Dashboard ")
const _hoisted_14 = { class: "navbar__item--mobile" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Sign in ")
const _hoisted_16 = { class: "navbar__item--mobile" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Sign up ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa_icon = _resolveComponent("fa-icon")!
  const _component_logo = _resolveComponent("logo")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_external_anchor = _resolveComponent("external-anchor")!

  return (_openBlock(), _createElementBlock("nav", {
    class: _normalizeClass(["navbar", { 'navbar--sticky': _ctx.sticky }])
  }, [
    (_ctx.navOpen)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("button", {
            class: "navbar__close",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeNav && _ctx.closeNav(...args)))
          }, [
            _createVNode(_component_fa_icon, { icon: ['far', 'times'] })
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_router_link, {
            class: "navbar__logo",
            to: "/"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_logo, { class: "navbar__logo-image" })
            ]),
            _: 1
          }),
          _createElementVNode("button", {
            class: "navbar__hamburger",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openNav && _ctx.openNav(...args)))
          }, [
            _createVNode(_component_fa_icon, { icon: ['far', 'bars'] })
          ])
        ])),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.navOpen ? 'navbar__drop-down--open' : 'navbar__drop-down')
    }, [
      _createElementVNode("ul", _hoisted_3, [
        _renderSlot(_ctx.$slots, "items", {}, () => [
          _createElementVNode("li", _hoisted_4, [
            _createElementVNode("a", {
              class: "anchor--primary",
              href: "#features",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goHome && _ctx.goHome(...args)))
            }, " Features ")
          ]),
          _createElementVNode("li", _hoisted_5, [
            _createElementVNode("a", {
              class: "anchor--primary",
              href: "#contact",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.goHome && _ctx.goHome(...args)))
            }, " Contact ")
          ]),
          _createElementVNode("li", _hoisted_6, [
            _createElementVNode("a", {
              class: "anchor--primary",
              href: "#pricing",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.goHome && _ctx.goHome(...args)))
            }, " Pricing ")
          ]),
          _createElementVNode("li", _hoisted_7, [
            _createVNode(_component_external_anchor, {
              class: "anchor--primary",
              href: "https://docs.steamcord.io",
              onClick: _ctx.closeNav
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ])
      ]),
      _createElementVNode("ul", _hoisted_9, [
        _renderSlot(_ctx.$slots, "items-last", {}, () => [
          (_ctx.isSignedIn)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("li", _hoisted_10, [
                  _createVNode(_component_router_link, {
                    class: "anchor--primary",
                    to: "/signout",
                    onClick: _ctx.closeNav
                  }, {
                    default: _withCtx(() => [
                      _hoisted_11
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _createElementVNode("li", _hoisted_12, [
                  _createVNode(_component_router_link, {
                    class: "button--primary",
                    to: "/dashboard",
                    onClick: _ctx.closeNav
                  }, {
                    default: _withCtx(() => [
                      _hoisted_13,
                      _createVNode(_component_fa_icon, { icon: ['far', 'arrow-right'] })
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("li", _hoisted_14, [
                  _createVNode(_component_router_link, {
                    class: "anchor--primary",
                    to: "/signin",
                    onClick: _ctx.closeNav
                  }, {
                    default: _withCtx(() => [
                      _hoisted_15
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _createElementVNode("li", _hoisted_16, [
                  _createVNode(_component_router_link, {
                    class: "button--primary",
                    to: "/signup",
                    onClick: _ctx.closeNav
                  }, {
                    default: _withCtx(() => [
                      _hoisted_17,
                      _createVNode(_component_fa_icon, { icon: ['far', 'arrow-right'] })
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ], 64))
        ])
      ])
    ], 2)
  ], 2))
}